<template>
    <div>
        <!-- Modal Transformação -->
        <div class="modal fade" id="transformApresentModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable modal-dialog-total" role="document">
                <div class="modal-content modal-content-total" v-if="dados">
                    <div class="modal-header">
                        <h5 class="modal-title">Transformação</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="mb-3 lead">
                            Solicitação: #{{ dados.item.id_estoque_solicitacao }}
                        </div>

                        <div class="alert alert-info d-flex justify-content-between">
                            <div>
                                {{ dados.item.item.search }}
                            </div>
                            <div>
                                {{ dados.item.in_quantidade }}
                                {{ dados.item.item.st_unidade_estoque }}
                            </div>
                        </div>

                        <table class="table table-sm" v-if="aprs">
                            <thead>
                                <tr>
                                    <th width="30%">Descrição</th>
                                    <th width="15%">Saldo</th>
                                    <th width="20%">Uso</th>
                                    <th width="20%">OverFill</th>
                                    <th class="text-right" width="15%">Total</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr class="table-secondary" key="titulo">
                                    <td>{{ dados.item.item.search }}</td>
                                    <td></td>
                                    <td class="text-right small text-muted">{{ dados.item.item.st_unidade_estoque }}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <template v-if="dados.item.item.saldo_por_lote && dados.item.item.saldo_por_lote.length">
                                    <tr v-for="(saldo, isx) in dados.item.item.saldo_por_lote" :key="'saldo' + isx" :class="( dados.item.item.qt_uso > dados.item.in_quantidade || dados.item.item.qt_uso > saldo.qtd ) ? 'table-danger' : ''">
                                        <td>
                                            {{ saldo.st_lote }}
                                        </td>
                                        <td>
                                            {{ saldo.qtd }}
                                            {{ dados.item.item.st_unidade_estoque }}
                                        </td>
                                        <td style="width: 140px">
                                            <div class="input-group input-group-sm">
                                                <input type="number" class="form form-control" :min="0" :max="dados.item.in_quantidade" v-model="saldo.qt_uso" placeholder="Qtde...">
                                                <div class="input-group-append">
                                                    <span class="input-group-text" id="basic-addon2">{{ dados.item.item.st_unidade_estoque }}</span>
                                                </div>
                                            </div>
                                        </td>
                                        <td style="width: 140px"></td>
                                        <td class="text-right" style="width: 140px">
                                            {{ saldo.qt_uso }} <span class="small text-muted">{{ dados.item.item.st_unidade_estoque }}</span>
                                        </td>
                                    </tr>
                                </template>

                                <template v-for="(apr, iax) in aprs">
                                    <tr :key="'apr' + iax" class="table-secondary" v-if="true">
                                        <td>{{ apr.st_estoque_item }}</td>
                                        <td></td>
                                        <td class="text-right">{{ apr.qt_apr }} <small class="text-muted">{{ dados.item.item.st_unidade_estoque }}</small></td>
                                        <td></td>
                                        <td></td>
                                    </tr>
                                    <template v-if="apr.saldo_por_lote && apr.saldo_por_lote.length">
                                        <tr v-for="(saldo, isx) in apr.saldo_por_lote" :key="iax + '.' + isx" :class="saldo.qtd < apr.qt_uso ? 'table-danger' : ''"> 
                                            <td>{{ saldo.st_lote }}</td>
                                            <td>{{ saldo.qtd }} <small class="text-muted">{{ apr.st_unidade_estoque }}</small></td>
                                            <td style="width: 140px">
                                                <div class="input-group input-group-sm">
                                                    <input type="number" class="form form-control" :disabled="!saldo.qtd" v-model="saldo.qt_uso" placeholder="Qtde...">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">{{ apr.st_unidade_estoque }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="width: 140px">
                                                <div class="input-group input-group-sm">
                                                    <input type="number" class="form form-control" v-model="saldo.qt_over" :disabled="!saldo.qt_uso" placeholder="Overfill...">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">{{ dados.item.item.st_unidade_estoque }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td class="text-right" style="width: 140px">{{ calc_qtd_apr(apr, saldo) }} <span class="small text-muted">{{ dados.item.item.st_unidade_estoque }}</span></td>
                                        </tr>
                                    </template>
                                    <template v-else>
                                        <tr :key="iax + '.SS'">
                                            <td>Sem Lote</td>
                                            <td>0 <small class="text-muted">{{ apr.st_unidade_estoque }}</small></td>
                                            <td style="width: 140px">
                                                <div class="input-group input-group-sm">
                                                    <input type="number" class="form form-control" disabled placeholder="Qtde...">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">{{ apr.st_unidade_estoque }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td style="width: 140px">
                                                <div class="input-group input-group-sm">
                                                    <input type="number" class="form form-control" disabled placeholder="Overfill...">
                                                    <div class="input-group-append">
                                                        <span class="input-group-text" id="basic-addon2">{{ dados.item.item.st_unidade_estoque }}</span>
                                                    </div>
                                                </div>
                                            </td>
                                            <td></td>
                                        </tr>
                                    </template>
                                </template>
                            </tbody>
                            <tfoot>
                                <tr :class="calc_qtd_total() >= dados.item.in_quantidade ? 'table-primary' : 'table-danger'">
                                    <th>Total</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th class="text-right">{{ calc_qtd_total() }} <span class="small text-muted">{{ dados.item.item.st_unidade_estoque }}</span></th>
                                </tr>
                                <tr class="table-success" v-if="calc_qtd_total() > dados.item.in_quantidade">
                                    <th>Sobra</th>
                                    <th></th>
                                    <th></th>
                                    <th></th>
                                    <th class="text-right">{{ sobra }} <span class="small text-muted">{{ dados.item.item.st_unidade_estoque }}</span></th>
                                </tr>
                            </tfoot>
                        </table>

                        <tmeplate v-if="false">
                            <pre class="alert alert-primary">{{ aprs }}</pre>
                            <pre class="alert alert-warning">{{ dados }}</pre>
                        </tmeplate>
                    </div>
                    <div class="modal-footer d-flex justify-content-between flex-column flex-md-row">
                        <div>
                            <az-input
                                type="checkbox-group"
                                label="Imprimir Etiqueta"
                                v-model="imprimir_etiqueta" />
                        </div>
                        <div>
                            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal">Cancelar</button>
                            <az-submit @click="atualizar()">Transformar</az-submit>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <estoque-etiqueta ref="estoque_etiqueta" />
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzSubmit from '../../util/AzSubmit.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import EstoqueEtiqueta from './EstoqueEtiqueta.vue';

export default {
    data() {
        return { 
            dados: null, 
            aprs: null, 
            imprimir_etiqueta: true, 
        }
        
    },

    components: { 
        AzSubmit,
        AzInput,
        EstoqueEtiqueta, 
    },

    computed: { 
        sobra: function () { 
            return this.calc_qtd_total() - parseInt(this.dados.item.in_quantidade);
        },
    },

    methods: { 
        atualizar () { 
            if ( Math.round(this.calc_qtd_total()) < Math.round(this.dados.item.in_quantidade) ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Transformar",
                    detail: "Quantidade insuficiente: \n" +  this.calc_qtd_total() + " < " + this.dados.item.in_quantidade,
                    life: 3000
                });
                return;
            }

            if ( this.sobra > 1000 ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Transformar",
                    detail: "Sobra inválida: " +  this.sobra,
                    life: 3000
                });
                return;
            }

            let dados = { 
                id_estoque_local: this.dados.id_estoque_local, 
                id_estoque_solicitacao: this.dados.item.id_estoque_solicitacao,
                id_estoque_item: this.dados.item.id_estoque_item,
                qt_uso: this.dados.item.item.qt_uso,
                aprs: this.aprs.flatMap(apr => { 
                        return apr.saldo_por_lote.map(item => { 
                            return { 
                                id_estoque_item: item.id_estoque_item,
                                st_lote: item.st_lote, 
                                qt_uso: item.qt_uso,
                                qt_over: item.qt_over,
                                qt_apr: apr.qt_apr
                            }
                        });
                    })
                    .filter(item => item.qt_uso > 0),
                total: this.calc_qtd_total(),
                sobra: this.sobra,
            };

            this.$util.atualizar(this, { 
                service: 'estoque', 
                func: 'transformar',
                dados: dados,
                callback: res => { 
                    console.log('retorno', res);

                    $('.modal').modal('hide');

                    this.$emit('reabrir', this.dados.item.id_estoque_solicitacao);

                    if ( this.imprimir_etiqueta ) { 
                        this.$nextTick(() => { 
                            this.emitir_etiqueta(res);
                        });
                    }
                }
            });
        },

        calc_qtd_apr (apr, saldo) { 
            if ( !saldo ) 
                return 0;

            return ( parseInt(apr.qt_apr ? apr.qt_apr : 0) * parseInt(saldo.qt_uso ? saldo.qt_uso : 0) ) 
                + ( saldo.qt_uso > 0 ? parseInt(saldo.qt_over ? saldo.qt_over : 0) : 0 );
        },

        calc_qtd_total () { 
            if ( !this.aprs ) 
                return 0;

            // let valor = this.dados.item.item.qt_uso ? parseInt(this.dados.item.item.qt_uso) : 0;
            let valor = this.dados.item.item.saldo_por_lote.reduce((total, carry) => { 
                return parseInt(total) + parseInt(carry.qt_uso ? carry.qt_uso : 0);
            }, 0);
            
            return valor + this.aprs.reduce((total, apr) => { 
                    if ( !apr.saldo_por_lote || !apr.saldo_por_lote.length ) { 
                        return parseInt(total);
                    }

                    return parseInt(total) + apr.saldo_por_lote.reduce((ta, ca) => { 
                            return parseInt(ta) + this.calc_qtd_apr(apr, ca);
                        }, 0);
                }, 0);
        },

        abrir(dados) { 
            this.aprs = null;

            if ( dados && dados.item && dados.item.item && dados.item.item.saldo_por_lote ) { 
                dados.item.item.saldo_por_lote.forEach(item => { 
                    item.qt_uso = "";
                    item.qt_over = "";
                });
            }

            dados.item.item.apresentacoes.forEach(apr => { 
                if ( apr.saldo_por_lote ) { 
                    apr.saldo_por_lote.forEach(item => { 
                        item.qt_uso = "";
                        item.qt_over = "";
                    });
                }
            });
            
            this.dados = _.cloneDeep(dados); 

            let ids = this.dados.item.item.apresentacoes.map((item) => item.id_estoque_item_ampola);

            this.$util.load(this, { 
                service: 'estoque_items', 
                func: 'index',
                parms: { 
                    ids: ids, 
                    id_estoque_local: this.dados.id_estoque_local,
                    saldos: true, 
                    lotes: true, 
                },
                loadTo: res => { 
                    res.forEach(item => {
                        let apr = this.dados.item.item.apresentacoes.find(apr => apr.id_estoque_item_ampola == item.id_estoque_item);
                        item.qt_apr = apr ? apr.in_quantidade : 1;
                        item.qt_uso = "";
                        item.qt_over = "";
                    });

                    this.aprs = res;
                }
            });

            $('#transformApresentModal').modal('show');
        },

        emitir_etiqueta(mov) {
            console.log('items', mov);

            if ( mov.mov ) { 

                const etiquetaItens = {
                    checked: true,
                    id_estoque_item: mov.mov.id_estoque_item,
                    lote: mov.mov.st_lote,
                    validade: mov.mov.dt_validade,
                    qtde: 1,
                    search: 'Item',
                };

                this.$refs.estoque_etiqueta.show([etiquetaItens]);

            }

        },

    }
}
</script>


<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}

.modal-dialog2 {
  width: 98% !important;
  min-height: 98% !important;
  padding: 0 !important;
  max-width: 100%;
}
</style>